<div *transloco="let t" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="add-container" (click)="addSetting()">
    <span>{{t('add_settings')}}</span>
</div>